import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface CaviarCardProps {
  name: string
  description: string
  image: string
  specs: {
    color: string
    size: string
    taste: string
  }
}

export function CaviarCard({ name, description, image, specs }: CaviarCardProps) {
  const { t } = useTranslation()
  return (
    <div className="product-card">
      <img src={image} alt={name} loading="lazy" />
      <span className="product-name">{name}</span>
      <div className="caviar-details">
        <p className="product-description">{description}</p>
        <div className="caviar-specs">
          <div className="spec">
            <span className="spec-label">Color:</span>
            <span>{specs.color}</span>
          </div>
          <div className="spec">
            <span className="spec-label">Size:</span>
            <span>{specs.size}</span>
          </div>
          <div className="spec">
            <span className="spec-label">Taste:</span>
            <span>{specs.taste}</span>
          </div>
        </div>
        <p className="pricing">{t('pricing.demand')}</p>
        <Link to="/contact#contact-form" className="btn product-cta">
          {t('cta.contact')}
        </Link>
      </div>
    </div>
  )
}